import { ProductReviewSummary } from '../ProductReview'
import { ProductVariantLite } from '../ProductVariant'

import BaseProduct, { IBaseProduct } from './BaseProduct'
import PRODUCT_DOMAIN_TYPES from './ProductDomainTypes'

interface ProductBrandInfo {
  link?: string
  name?: string
  displayName?: string
}

export type IProductLite = IBaseProduct<ProductVariantLite> & {
  readonly productReviewSummary?: Pick<ProductReviewSummary, 'averageRating'> | undefined
  readonly productBrandInfo: ProductBrandInfo
}

export default class ProductLite extends BaseProduct<ProductVariantLite> implements IProductLite {
  readonly productReviewSummary?: Pick<ProductReviewSummary, 'averageRating'> | undefined
  readonly productBrandInfo: ProductBrandInfo
  readonly productDomainTypes = PRODUCT_DOMAIN_TYPES.PRODUCT_LITE

  constructor(iProductLite: IProductLite) {
    super(iProductLite, PRODUCT_DOMAIN_TYPES.PRODUCT_LITE)
    this.productReviewSummary = iProductLite.productReviewSummary
    this.productBrandInfo = iProductLite.productBrandInfo
    return {
      ...this,
    }
  }
}
